export default {
    en: {
        removebtn: 'Remove',
        basicLevelPlatform: 'Basic Level Platform',
        secondaryPlatform: 'Secondary Platform',
        selectAll: 'Select All',
        deviceList: 'Device List',
        platName: 'Platform Name',
        isPlatLocal: 'Local Platform',
        platCode: 'Platform National Standard Code',
        platIP: 'IP',
        platPort: 'Port',
        platUserName: 'Username',
        platPassword: 'Password',
        platHeartInterval: 'Heartbeat Sending Interval',
        platMaxBeats: 'Maximum Number of Beats',
        platSetting: 'Platform Settings',
        addPlatform: 'Add Platform',
        remove: 'Remove',
        cancel: 'Cancel',
        save: 'Save',
        input: 'Input',
        yes: 'Yes',
        no: 'No',
        times: 'Times',
        seconds: 'Seconds',
        platNamePlaceholder: 'Please enter national standard platform name',
        codePlaceholder: 'Please enter platform national standard code',
        ipPlaceholder: 'Please enter IP',
        portPlaceholder: 'Please enter port',
        userNamePlaceholder: 'Please enter username',
        passwordPlaceholder: 'Please enter password',
        heartIntervalPlaceholder: 'Please enter heartbeat sending interval',
        maxBeatsPlaceholder: 'Please enter maximum number of beats',
        accessPlatform: 'Access Platform',
        deviceName: 'Device Name',
        groupName: 'Group Name',
        deviceId: 'Device ID',
        reviewPlatform: 'Review Platform',
        reviewId: 'Review ID',
        notes: 'Notes',
        accessPlatformPlaceholder: 'Please enter access platform',
        deviceNamePlaceholder: 'Please enter device name',
        groupNamePlaceholder: 'Please enter group name',
        deviceIdPlaceholder: 'Please enter device ID',
        reviewPlatformPlaceholder: 'Please enter review platform',
        reviewIdPlaceholder: 'Please enter review ID',
        notesPlaceholder: 'Please enter notes',
        nationalCode: 'International Code',
        diveListPlaceholder: 'Please select a device',
        colosed: 'Colose',
        searchDevice: 'Please enter International Code',
        tipCon: "The system doesn’t support multiple protocol devices to export at the same time, please select the device protocol type and try again.",
        tip: "Tip",
        gbTipCon: "GB28181 type does not support export"
    },
    zh: {
        gbTipCon: "GB28181类型不支持导出",
        tip: "提示",
        tipCon: "系统不支持同时导出多个协议设备，请选择设备协议类型，然后重试。",
        searchDevice: '请输入国际编码',
        removebtn: '撤销',
        basicLevelPlatform: '本级平台',
        secondaryPlatform: '下级平台',
        selectAll: '全选',
        deviceList: '设备列表',
        platName: '国标平台名称',
        isPlatLocal: '是否本地平台',
        platCode: '平台国际编码',
        platIP: 'IP地址',
        platPort: '端口号',
        platUserName: '用户名',
        platPassword: '密码',
        platHeartInterval: '心跳发送间隔',
        platMaxBeats: '最大心跳超时次数',
        platSetting: '平台设置',
        addPlatform: '添加平台',
        remove: '删除',
        cancel: '取消',
        save: '保存',
        input: '请输入',
        yes: '是',
        no: '否',
        times: '次数',
        seconds: '秒',
        platNamePlaceholder: '请输入国标平台名称',
        codePlaceholder: '请输入平台国际编码',
        ipPlaceholder: '请输入IP地址',
        portPlaceholder: '请输入端口号',
        userNamePlaceholder: '请输入用户名',
        passwordPlaceholder: '请输入密码',
        heartIntervalPlaceholder: '请输入心跳发送间隔',
        maxBeatsPlaceholder: '请输入最大心跳超时次数',
        accessPlatform: '接入平台',
        deviceName: '设备名称',
        groupName: '分组名称',
        deviceId: '设备ID',
        reviewPlatform: '回放平台',
        reviewId: '回放ID',
        notes: '备注',
        accessPlatformPlaceholder: '请输入接入平台',
        deviceNamePlaceholder: '请输入设备名称',
        groupNamePlaceholder: '请输入分组名称',
        deviceIdPlaceholder: '请输入设备ID',
        reviewPlatformPlaceholder: '请输入回放平台',
        reviewIdPlaceholder: '请输入回放ID',
        notesPlaceholder: '请输入备注',
        nationalCode: '国标码',
        diveListPlaceholder: '请选择设备',
        colosed: '关闭'
    }
};
